'use client';
import styled from 'styled-components';
import { colors, mixins, breakPoints } from '@/styles';

export const ReferralBanner = styled.div`
  position: relative;
  background: ${colors.primary.white};
  ${mixins.animatedGradientBorder({ borderRadius: 5, borderWidth: 2, glow: { size: '1rem', opacity: 0.25 } })};
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 25px;
  justify-content: space-between;

  background: ${colors.primary.white};
  padding: 20px;

  @media (max-width: ${breakPoints.mobile}) {
    flex-direction: column;
    gap: 10px;
    button {
      width: 100%;
    }
  }
`;
